<template>
    <div class="popup">
        <div class="popup-container">
            <div class="popup-header">
                <slot name="popup-header"></slot>
            </div>
            <div class="popup-content">
                <slot name="popup-content"></slot>
            </div>
            <div class="popup-footer ">
                <slot name="popup-footer"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Structure_Popup"
}
</script>